import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    roleSelectData;
    currVal;
    isDisabled;
    isMultiple;
    currIndex = '';
    defaultExpandKey = [];
    value1 = [];
    get limit() {
        const res = this.isMultiple ? this.isMultiple : 0;
        return res;
    }
    handleCheckChange(data, checked) {
        console.log('data:', this.value1);
        this.$emit('onCheckedNode', this.value1);
        // this.getCheckedKeys();
    }
    // getCheckedKeys(){
    //   console.log((this.$refs.tree as any).getCheckedNodes());
    //   const checkedNodes:Array<{id: string, label:string}> = (this.$refs.tree as any).getCheckedNodes();
    //   this.$emit('onCheckedNode', checkedNodes);
    //   const roleNames = checkedNodes.map(item=> item.label).join(',');
    //   this.value=roleNames;
    // }
    onOpenChange(newVal) {
        this.value1 = this.currVal;
    }
};
__decorate([
    Prop()
], default_1.prototype, "roleSelectData", void 0);
__decorate([
    Prop()
], default_1.prototype, "currVal", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "isDisabled", void 0);
__decorate([
    Prop({ default: 0 })
], default_1.prototype, "isMultiple", void 0);
__decorate([
    Watch('currVal')
], default_1.prototype, "onOpenChange", null);
default_1 = __decorate([
    Component({
        name: 'RoleTree',
        i18n: {
            messages: {
                'en-us': {},
                zh: {},
            },
        },
    })
], default_1);
export default default_1;
